<template>
  <UserList search-type="2" />
</template>

<script>
import UserList from '@/components/UserList'

export default {
  name: 'PopularUsers',
  components: {
    UserList,
  }
}
</script>
